var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartlyRainSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 428.14 367.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#032635;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4922.49,2021.13c-17.06-22.81-15.92-62.15-16.74-49.56-2.13,32.89-15.07,49.56-15.07,49.56a14.5,14.5,0,0,0-1.71,6.74c0,8.69,7.89,15.76,17.6,15.76s17.61-7.07,17.61-15.76a14.27,14.27,0,0,0-1.72-6.74Z",
    transform: "translate(-4687.39 -1676.46)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5011.85,1729.81a51,51,0,0,0-43.73,77.3,55,55,0,0,0-40.57,7c-5.36-31.43-34.17-55-67.91-53.11-32.09,1.6-57.53,25.08-61.69,55.22a53.22,53.22,0,0,0-17.87-3.11,55.3,55.3,0,0,0-55.25,55.24c0,.65,0,1.3.09,2-15.43,4.2-37.57,13.11-37.53,44.66,0,23.45,19.5,43.56,46,44.83l8.13-12.55c-1,0-2.07.06-2.81.1l-2,0c-20.14,0-36.53-14.56-36.55-32.43,0-21.31,11.61-28.23,33.1-33.56l4.83-1.84.13-4.87-.24-2.62a28,28,0,0,1-.36-3.78,42.43,42.43,0,0,1,42.39-42.38,41.76,41.76,0,0,1,20.57,5.57l9.76,5.46-.19-11.17c-.48-27.73,21.52-50.57,50.05-52l2.78-.07c28.08,0,51.13,21.27,52.47,48.47.06,1,0,1.94-.14,4.42l-.57,16.52,11.59-11.79a42.35,42.35,0,0,1,71.72,38.15l-1.31,6.46,6.5,1.14c16.55,2.9,28.63,15.73,29.39,31.18s-9.92,33.16-26.14,38.26l4.29,12c20.46-6.8,35.83-28,34.69-50.85-1-19.5-14.59-35.94-33.93-41.77.15-1.61.23-3.24.23-4.85a54.83,54.83,0,0,0-8.93-30,51,51,0,1,0,8.94-101.3Zm0,93.23a42.17,42.17,0,1,1,42.16-42.16A42.2,42.2,0,0,1,5011.85,1823Z",
    transform: "translate(-4687.39 -1676.46)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4966.77,1741.05a3.54,3.54,0,1,0,5.32-4.67l-26.39-30.17a3.55,3.55,0,0,0-5.35,4.68Z",
    transform: "translate(-4687.39 -1676.46)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5012,1723.64a3.52,3.52,0,0,0,3.5-3.56l-.28-40.08a3.54,3.54,0,1,0-7.08,0l.28,40.09A3.54,3.54,0,0,0,5012,1723.64Z",
    transform: "translate(-4687.39 -1676.46)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4910.7,1775l39.93,3.26a3.56,3.56,0,0,0,.58-7.09l-39.95-3.25a3.55,3.55,0,0,0-.56,7.08Z",
    transform: "translate(-4687.39 -1676.46)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5103.26,1829l-35.48-18.64a3.55,3.55,0,1,0-3.3,6.28l35.47,18.65a3.55,3.55,0,0,0,3.31-6.29Z",
    transform: "translate(-4687.39 -1676.46)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5111.57,1761.66l-39.79,4.66a3.55,3.55,0,0,0,.8,7.06l39.83-4.67a3.55,3.55,0,0,0-.84-7Z",
    transform: "translate(-4687.39 -1676.46)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5028.64,1833.29a3.52,3.52,0,0,0-2.17,4.52l13.32,37.8a3.55,3.55,0,1,0,6.69-2.36l-13.33-37.81A3.51,3.51,0,0,0,5028.64,1833.29Z",
    transform: "translate(-4687.39 -1676.46)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5053,1737.36l24.66-31.57a3.54,3.54,0,1,0-5.59-4.36L5047.45,1733a3.54,3.54,0,1,0,5.59,4.34Z",
    transform: "translate(-4687.39 -1676.46)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4802.31,2009.88c-21.33-28.57-19.91-77.78-20.92-62-2.68,41.14-18.89,62-18.89,62a18.07,18.07,0,0,0-2.13,8.42c0,10.88,9.86,19.72,22,19.72s22-8.84,22-19.72a17.84,17.84,0,0,0-2.14-8.42Z",
    transform: "translate(-4687.39 -1676.46)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4870,1971.12c-18.61-24.95-17.37-67.9-18.27-54.15-2.34,35.92-16.48,54.15-16.48,54.15a15.53,15.53,0,0,0-1.85,7.35c0,9.51,8.6,17.23,19.23,17.23s19.22-7.72,19.22-17.23a15.79,15.79,0,0,0-1.87-7.35Z",
    transform: "translate(-4687.39 -1676.46)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4933.11,1922.91c-1.35,20.69-9.49,31.19-9.49,31.19a8.92,8.92,0,0,0-1.08,4.23c0,5.48,4.95,9.93,11.09,9.93s11.06-4.45,11.06-9.93a9,9,0,0,0-1.06-4.23C4932.9,1939.74,4933.63,1915,4933.11,1922.91Z",
    transform: "translate(-4687.39 -1676.46)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartlyRainSun);
export default __webpack_public_path__ + "static/media/partlyRainSun.e82759e435e6598977a89056cd8b1d11.svg";
export { ForwardRef as ReactComponent };